import React from 'react'
import { Center, Grid, Box, theme, Text } from '@lojinha/design-system'
import { t } from '../../dictionary'
import {
  numberToCurrency,
  numberToCurrencyAriaLabel,
} from '../../helpers/formatNumber'
import { CardsGroup } from '../../components/cards-group'
import { MGMHowItWorks } from '../../components/mgm-how-it-works'
import { IndicationCode } from '../../components/indication-code'
import { MGMReferralList } from '../../components/mgm-referral-list'
import { useIndication } from './hook'
import { Loading } from './loading'

export const Indications = () => {
  const {
    loading,
    referralCouponCode,
    referralRewardAmount,
    referralCredit,
    referralDiscount,
    usageCount,
    couponUsages,
  } = useIndication()

  if (loading) return <Loading />

  return (
    <Center htmlAttrs={{ style: { width: '100%' } }}>
      <Box
        display="grid"
        py="x64"
        htmlAttrs={{
          style: { gridTemplateColumns: 'repeat(12, 1fr)' },
        }}
      >
        <Grid
          gridColumn={['2/12', '2/12', '3/6']}
          htmlAttrs={{ style: { marginBottom: theme.space.x40 } }}
        >
          {referralCouponCode && (
            <IndicationCode
              title={`${t.mgm.title} ${numberToCurrency(
                referralRewardAmount
              )} ${t.inCredits}`}
              ariaLabelBtn={`${t.mgm.buttonAriaLabel} ${referralCouponCode}`}
              code={referralCouponCode}
              description={[
                { text: `${t.mgm.description} \n` },
                { text: t.mgm.descriptionFirstOrder },
                {
                  text: `${t.mgm.earn} ${numberToCurrency(
                    referralRewardAmount
                  )} `,
                  isBold: true,
                },
                { text: t.mgm.descriptionTheyEarn },
                {
                  text: `${referralDiscount}% ${t.mgm.descriptionDiscount}`,
                  isBold: true,
                },
              ]}
              ariaLabelDescription={`${t.mgm.description} ${
                t.mgm.descriptionFirstOrder
              } ${t.mgm.earn} ${numberToCurrencyAriaLabel(
                referralRewardAmount
              )} ${t.mgm.descriptionTheyEarn} ${referralDiscount} ${
                t.mgm.percent
              } ${t.mgm.descriptionDiscount}`}
            />
          )}
        </Grid>
        <Grid
          gridColumn={['2/12', '2/12', '7/11']}
          htmlAttrs={{
            style: { alignSelf: 'baseline' },
          }}
        >
          <CardsGroup credits={referralCredit} acceptedInvites={usageCount} />
        </Grid>
      </Box>
      <MGMHowItWorks />
      {!!couponUsages?.totalCount && (
        <Box
          display="grid"
          px="x16"
          py={['x40', 'x40', 'x64']}
          htmlAttrs={{
            style: { gridTemplateColumns: 'repeat(10, 1fr)' },
          }}
        >
          <Grid
            gridColumn={['1/10', '2/10', '2/4']}
            htmlAttrs={{ style: { marginBottom: theme.space.x40 } }}
          >
            <Text
              textSize={['x2', 'x2', 'x3']}
              textTransform="uppercase"
              isBrand
            >
              {t.mgm.referralDescription}
            </Text>
          </Grid>
          <Grid gridColumn={['1/11', '2/10', '5/10']}>
            <MGMReferralList referrals={couponUsages.nodes} />
          </Grid>
        </Box>
      )}
    </Center>
  )
}
